<template>
	<v-card class="questions-page elevation-0">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null" class="d-flex">
			<div class="questions-page__wrapper d-flex flex-column">
				<div class="d-flex justify-end align-center mb-3">
					<button
						type="button"
						class="questions-page__button-add elevation-0"
						@click="toggleQuestionModal"
					>
						Ask
					</button>
				</div>

				<v-skeleton-loader
					v-if="isLoading && !this.sessionQuestions"
					type="text, text, text"
					v-bind="attrs"
				/>

				<div
					v-if="!isLoading && this.sessionQuestions && this.sessionQuestions.length === 0"
					class="mt-5"
				>
					<NewsFeedEmpty
						title="There are no questions for the session now."
						description="Add your question."
					/>
				</div>

				<div v-else>
					<div
						class="questions-page__item"
						v-for="question in sessionQuestions"
						:key="question.session_question_answer_id"
					>
						<div class="questions-page__item-title">
							{{ question.session_question_answer_text }}
						</div>
						<button
							type="button"
							class="questions-page__item-count d-flex align-center flex-nowrap ml-2 elevation-0"
							:class="question.upvote ? 'questions-page__item-count-upvote' : ''"
							@click="upvote(question.session_question_answer_id, question.upvote)"
						>
							<Icon
								type="like"
								:color="
									question.upvote
										? 'var(--button-secondary-background-color)'
										: '#697583'
								"
								:size="24"
							/>
							<span class="questions-page__item-count-value ml-2">
								{{ question.session_question_count }}
							</span>
						</button>
					</div>
				</div>

				<div
					class="d-flex my-9 justify-center questions-page__pagination"
					v-if="sessionQuestions && sessionQuestions.length > 0"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.sessionQuestionsMeta.pageCount"
						v-on:pageChange="onPageChange"
					/>
				</div>

				<div v-if="addQuestionModalIsOpen">
					<AddSessionQuestionModal
						:show="addQuestionModalIsOpen"
						:qaIsAutocomplete="!!session.session_qa_auto_complete"
						:isQuestionsPage="true"
						v-on:closeModal="toggleQuestionModal"
					/>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import AddSessionQuestionModal from '@/components/Modals/AddSessionQuestionModal.vue'
import Pagination from '@/components/Pagination.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import { mapActions, mapGetters } from 'vuex'

export default {
	mixins: [Block],
	components: {
		AddSessionQuestionModal,
		Pagination,
		NewsFeedEmpty,
		PageBlocked,
	},
	data() {
		return {
			addQuestionModalIsOpen: false,
			filters: {
				page: 1,
			},
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			pageBlockedName: 'events',
		}
	},
	methods: {
		...mapActions('event', [
			'getSession',
			'getSessionQuestions',
			'upvoteSessionQuestion',
			'deleteUpvoteSessionQuestion',
		]),
		...mapActions('app', ['setPageTitle']),

		toggleQuestionModal() {
			if (!this.isLoading) {
				this.addQuestionModalIsOpen = !this.addQuestionModalIsOpen
			}
		},
		upvote(id, upvote) {
			if (!this.isLoading) {
				upvote ? this.deleteUpvoteSessionQuestion(id) : this.upvoteSessionQuestion(id)
			}
		},
		onPageChange(page) {
			if (page !== this.filters.page) {
				this.filters.page = page
				this.getSessionQuestions({
					sessionId: this.$route.params.sessionId,
					session: !!this.session,
					page: this.filters.page,
				})
			}
		},
	},
	computed: {
		...mapGetters('event', [
			'isLoading',
			'session',
			'sessionQuestions',
			'sessionQuestionsMeta',
		]),
	},
	mounted() {
		this.setPageTitle('Session Q&A')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.getSession(this.$route.params.id)
			this.getSessionQuestions({
				sessionId: this.$route.params.id,
				session: !!this.session,
			})
		}
	},
}
</script>

<style lang="scss">
.questions-page {
	background-color: transparent !important;
	max-width: 555px;
	width: 100%;

	&__wrapper {
		width: 100%;
	}

	&__title {
		font-family: 'Inter', sans-serif;
		font-weight: 500;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--accent-color);
	}

	&__button {
		&-back,
		&-add {
			padding: 0 3px;
			background-color: transparent !important;
			color: #0055a3 !important;
			text-transform: capitalize;
			font-size: 16px !important;
			font-weight: 700;
			font-family: 'Inter', sans-serif;
			text-decoration: underline;
			cursor: pointer;
		}
	}

	&__item {
		border-radius: 8px;
		background-color: #ffffff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		min-height: 66px !important;
		padding: 12px;
		border: 1px solid #e2e2e2;

		&:not(:last-child) {
			margin-bottom: 8px;
		}

		&-title {
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--accent-color);
			word-break: break-word;
		}

		&-count {
			background-color: transparent !important;

			&-upvote {
				span {
					color: #0055a3;
				}
			}
		}

		&-count-value {
			font-size: 13px;
			font-weight: 500;
			line-height: 19.37px;
			font-family: Montserrat, sans-serif;
			color: #697583;
		}
	}
}
</style>
